import * as zhenhanDev from './clients/zhenhan/development'
import * as zhenhanProd from './clients/zhenhan/production'
import * as zhenhanTest from './clients/zhenhan/test'
import * as dikanongDev from './clients/dikanong/development'
import * as dikanongProd from './clients/dikanong/production'
import * as dikanongTest from './clients/dikanong/test'
import * as jienshiDev from './clients/jienshi/development'
import * as jienshiProd from './clients/jienshi/production'
import * as jienshiTest from './clients/jienshi/test'

const configs = {
  zhenhan: {
    development: zhenhanDev.default,
    production: zhenhanProd.default,
    test: zhenhanTest.default,
  },
  dikanong: {
    development: dikanongDev.default,
    production: dikanongProd.default,
    test: dikanongTest.default,
  },
  jienshi: {
    development: jienshiDev.default,
    production: jienshiProd.default,
    test: jienshiTest.default,
  },
}

class ClientConfig {
  constructor() {
    this.currentConfig = null
    this.currentClient = null
    this.currentEnv = null
  }

  init(clientId, env) {
    if (!configs[clientId]) {
      throw new Error(`未找到客户配置: ${clientId}`)
    }
    if (!configs[clientId][env]) {
      throw new Error(`未找到环境配置: ${clientId}/${env}`)
    }

    this.currentClient = clientId
    this.currentEnv = env
    this.currentConfig = configs[clientId][env]

    // 保存当前客户和环境信息到 localStorage
    localStorage.setItem('current_client', clientId)
    localStorage.setItem('current_env', env)

    return this.currentConfig
  }

  getConfig() {
    if (!this.currentConfig) {
      throw new Error('客户配置未初始化')
    }
    return this.currentConfig
  }

  // 添加获取Token配置的方法
  getAuthConfig() {
    if (!this.currentConfig) {
      throw new Error('客户配置未初始化')
    }
    return this.currentConfig.auth || {}
  }

  // 获取客户端配置信息
  getClientConfig() {
    if (!this.currentConfig) {
      throw new Error('客户配置未初始化')
    }
    
    // 返回与config.json结构相似的对象
    return {
      appid: this.currentConfig.auth?.appid,
      app_secret: this.currentConfig.auth?.app_secret,
      client: [
        {
          client_id: this.currentConfig.clientId,
          contact_person_tab_list: this.currentConfig.clientConfig?.contact_person_tab_list || []
        }
      ]
    }
  }

  getCurrentClient() {
    return this.currentClient
  }

  getCurrentEnv() {
    return this.currentEnv
  }

  isProduction() {
    return this.currentEnv === 'production'
  }

  isDevelopment() {
    return this.currentEnv === 'development'
  }

  isTest() {
    return this.currentEnv === 'test'
  }

  validateUser(userId) {
    if (!this.currentConfig) {
      return false
    }
    return this.currentConfig.allowedUsers.includes(userId)
  }
}

export default new ClientConfig() 